<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-md-offset-1">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard error-color="#EB5E28" color="#1e94fd" title="Ingresos" subtitle="" @on-complete="siguente">
            <tab-content v-if="this.getKey('tipo_dec') === 'Inicial'" :before-change="addItem" title="Ingresos netos del declarante, pareja y/o dependientes económicos (situación actual)" icon="ti-user">
              <sueldos-salarios ref="SueldosSalarios"></sueldos-salarios>
            </tab-content>
            <tab-content :before-change="addItem55" title="Situación patrimonial año anterior" icon="ti-user">
              <sueldos-salarios-otros ref="SueldosSalariosOtros"></sueldos-salarios-otros>
            </tab-content>
            <!-- <tab-content title="Sueldos y Salarios Públicos" icon="ti-user">
              <sueldos-salarios ref="SueldosSalarios"></sueldos-salarios>
            </tab-content>
            <tab-content v-if="this.grupo != 3" title="Sueldos y Salarios por Otros Empleos" icon="ti-user">
              <sueldos-salarios-otros ref="SueldosSalariosOtros"></sueldos-salarios-otros>
            </tab-content>

            <tab-content v-if="this.grupo != 3" title="Actividad Profesional" icon="ti-user">
              <actividad-profesional ref="Actividad Profesional"></actividad-profesional>
            </tab-content>
            <tab-content v-if="this.grupo != 3" title="Actividad Empresarial" icon="ti-user">
              <actividad-empresarial ref="Actividad Empresarial"></actividad-empresarial>
            </tab-content>
            <tab-content v-if="this.grupo != 3" title="Actividad Económica" icon="ti-user">
              <actividad-economica ref="ActividadEconomica"></actividad-economica>
            </tab-content>

            <tab-content v-if="this.grupo != 3" title="Arrendamiento" icon="ti-user">
              <arrendamiento ref="Arrendamiento"></arrendamiento>
            </tab-content>

            <tab-content v-if="this.grupo != 3" title="Intereses" icon="ti-user">
              <intereses ref="Intereses"></intereses>
            </tab-content>

            <tab-content v-if="this.grupo != 3" title="Premios" icon="ti-user">
              <premios ref="Premios"></premios>
            </tab-content>

            <tab-content v-if="this.grupo != 3" title="Enajenacion" icon="ti-user">
              <enajenacion ref="Enajenacion"></enajenacion>
            </tab-content>

            <tab-content v-if="this.grupo != 3" title="Otros Ingresos" icon="ti-user">
              <otros-ingresos ref="OtrosIngresos"></otros-ingresos>
            </tab-content>-->
            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Atrás</button>
            <button slot="next" class="btn btn-info btn-fill btn-wd btn-next">Siguiente</button>
            <button slot="finish" class="btn btn-info btn-fill btn-wd btn-next">Siguientes</button>
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import SueldosSalarios from './Formularios/Ingresos/SueldosSalarios.vue'
  import SueldosSalariosOtros from './Formularios/Ingresos/SueldosSalariosOtros.vue'
  import ActividadProfesional from './Formularios/Ingresos/ActividadProfesional.vue'
  import ActividadEmpresarial from './Formularios/Ingresos/ActividadEmpresarial.vue'
  import ActividadEconomica from './Formularios/Ingresos/ActividadEconomica.vue'
  import Arrendamiento from './Formularios/Ingresos/Arrendamiento.vue'
  import Intereses from './Formularios/Ingresos/Intereses.vue'
  import Premios from './Formularios/Ingresos/Premios.vue'
  import Enajenacion from './Formularios/Ingresos/Enajenacion.vue'
  import OtrosIngresos from './Formularios/Ingresos/OtrosIngresos.vue'
  import swal from 'sweetalert2'
  export default {
    data() {
      return {
        wizardModel: {},
        // grupo: null

      }
    },
    components: {
      FormWizard,
      TabContent,
      SueldosSalarios,
      SueldosSalariosOtros,
      ActividadProfesional,
      ActividadEmpresarial,
      ActividadEconomica,
      Arrendamiento,
      Intereses,
      Premios,
      Enajenacion,
      OtrosIngresos
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      checkPermissions() {
        if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();
        }

      },
      addItem() {

        return new Promise((resolve, reject) => {
          //this.$validator.validateAll().then(response => {
          //this.$refs.DatosPersonales.validateAll().then(response => {
          this.$refs.SueldosSalarios.valida().then(response => {
            //this.$refs.SueldosSalarios.item_entes
            this.item_entes = this.$refs.SueldosSalarios.item_entes
            console.log(response);
            if (response) {
              this.item_entes.ip_id = this.ip_id
              this.loadButton(this.$refs.btnSave)
              this.$http.post('sueldos_publicos', this.item_entes).then(
                response => {
                  this.StepOk('Guardado')
                  // if (this.edit_item === undefined || this.edit_item === null) {
                  // this.item_entes = data.response.sueldos
                  // }
                  // this.showItem()
                  // this.initItem()
                  //  this.edit_item = null
                  return resolve(true) //después de enviar, deja continuar
                },
                error => {
                  this.StepW(error)
                  // this.change =  true;
                }
              )

            } else
              return resolve(false);
          })
        })

      },
      addItem55() {
        this.item_entes22 = this.$refs.SueldosSalariosOtros.item_entes22;
        var v = this;
        return new Promise((resolve, reject) => {
          //el tab wizard necesita que se regrese una promesa para dejar continuar
          this.$refs.SueldosSalariosOtros.validate().then(
            response => {

              if (response) {

                this.item_entes22.ip_id = this.ip_id;
                /* this.loadButton(this.$refs.btnSave); */
                this.$http.post("sueldos_otros", this.item_entes22).then(
                  response => {
                    // console.log(response)
                    this.StepOk("Guardado");
                    /* if (this.edit_item === undefined || this.edit_item === null) {
                      this.list_entes.push({
                        ...response.data.sueldo
                      });
                    } else {
                      this.list_entes.splice(
                        this.edit_item.index,
                        1,
                        this.item_entes22
                      );
                      this.edit_item.item._rowVariant = "";
                    }
                    this.showItem();
                    this.initItem();
                    this.edit_item = null;*/
                    return resolve(true) //después de enviar, deja continuar
                  },
                  error => {
                    this.StepW(error);
                  }
                );
              } else {
                this.StepW("Hay campos sin completar");
                return reject(false)
              }

            }).catch(e => {
            reject(false)
          });


          /* if (this.item_entes22) {

          } else {
            this.StepW("Hay campos sin completar");
            return reject(false) //si no todo es valido, no deja continuar
          } */
        })
        //console.log(this.item_entes22);


      },
      /* siguente() {
        this.$router.push('activos');
      }, */
      siguente() {
        var simplificada = this.getKey('simplificada');
        if (simplificada == '1') {
          this.$router.push('fiscal');
        } else {
          this.$router.push('activos');
        }

        // if (this.grupo != 3) {

        // } else {
        //   this.$router.push('resumen');

        // }
      },
      validateFirstStep() {
        return this.$refs.firstStep.validate()
      },
      validateSecondStep() {
        return this.$refs.secondStep.validate()
      },
      wizardComplete() {
        // we gather models from all steps into one model
        this.wizardModel = {
          ...this.$refs.datosPersonales.model,
          ...this.$refs.firstStep.model,
          ...this.$refs.DatosCurriculares.model,
          ...this.$refs.DatosConyuge.model,
          ...this.$refs.secondStep.model
        }
        swal('Good job!', 'You clicked the finish button!', 'success')
      }
    },
    created() {
      this.checkPermissions()
      // this.grupo = this.getKey('grupo')
    }
  }

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9A9A9A !important;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Ingresos.vue